import Section01 from "./Section01";
import Section02 from "./Section02";
import Section03 from "./Section03";
import Section04 from "./Section04";

function Sections({ config }) {
  return (
    <div className="bg-slate-100 transition pb-10">
      <Section03 config={config} />
      <Section01 config={config} />
      <Section02 config={config} />
      <Section04 config={config} />
    </div>
  );
}

export default Sections;
